import { AuthCtx, isFlipperEnabled } from 'context'

export const isInfraDebugButtonEnabled = (authContext: AuthCtx) => {
  return isFlipperEnabled(authContext, 'self_service_ui_infra_debug_button')
}
